import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authRedirectGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.isLoggedIn()) {
    if (!authService.isMfaEnrolled()) {
      router.navigate(['/auth/mfa']);
    } else {
      router.navigate(['/dashboard/home']);
    }
    return false;
  } else {
    return true;
  }
};
